import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useCatalog } from "../context/CatalogContext";
// import SearchComponent from "../components/SearchComponent";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IconComponent } from "../components/IconComponent";
import { formatTitleForURL } from "../utils/stringUtils";
import { formatCurrency } from "../utils/numberFormatter";
import { RiAlignItemLeftLine } from "react-icons/ri";
import { TbCategoryFilled } from "react-icons/tb";
import * as Types from "../data-types/api-client/api-products";

const Products = () => {
  const {
    provisionData,
    setOriginalTitle,
    selectedCategory,
    setSelectedCategory,
  } = useCatalog();

  // const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1366); // Adjust breakpoint as needed

  const categories: Types.RentCategory[] = provisionData?.categories;
  const category: Types.RentCategory | undefined = categories?.find(
    (cat) => cat.id === selectedCategory,
  );
  const devices: Types.RentDevice[] = provisionData?.priceList?.devices;
  const [filteredDevices, setFilteredDevices] = useState<Types.RentDevice[]>(
    [],
  );
  let formattedTitle = "";

  const handleCategorySelect = (categoryId: number) => {
    setSelectedCategory(categoryId);
    setFilteredDevices(
      devices?.filter((device) => device.rentCategoryId === categoryId),
    );
  };

  const handleItemClick = (
    originalTitle: string,
    activeProductIndex: number,
    categoryId: number,
  ) => {
    setOriginalTitle(originalTitle); // Set the original title in context
    formattedTitle = formatTitleForURL(originalTitle.toLowerCase());
    const catTitle = categories?.find((cat) => cat.id === categoryId)?.name;
    const formattedCategoryTitle = catTitle
      ? formatTitleForURL(catTitle.toLowerCase())
      : "";
    navigate(
      `/prenajom-zariadeni/${formattedCategoryTitle}/${formattedTitle}/${activeProductIndex}`,
    );
  };

  const scrollToSection = () => {
    const section = document.getElementById("productSection");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (!selectedCategory) {
      setSelectedCategory(1);
      setFilteredDevices(
        devices?.filter((device) => device.rentCategoryId === categories[0].id),
      );
    }

    setFilteredDevices(
      devices?.filter((device) => device.rentCategoryId === category?.id),
    );
  }, [devices, categories]);

  // Handle window resizing
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {/* <SearchComponent /> */}
      {/* {error && <p>Error: {error}</p>} */}
      <div className="flex flex-col items-center w-full 2xl:w-3/4 justify-self-center pb-8">
        <div className="md:px-20 flex flex-col pt-4 pb-4 w-full justify-center h-auto text-custom-atrament min-h-48 bg-custom-gray">
          <div className="flex w-full items-center gap-2 pb-3 pl-4 md:pl-0">
            <span className="flex items-center justify-center w-9 h-9 rounded-xl text-custom-red bg-custom-white">
              <TbCategoryFilled className="text-lg" />
            </span>

            <h2 className="flex w-full justify-start items-center uppercase text-custom-blue font-semibold text-base">
              Kategórie
            </h2>
          </div>
          <div className="flex flex-wrap flex-row gap-4 justify-start justify-self-center pl-4 md:pl-0">
            {/* Category Navigation Buttons */}
            {categories?.map((category, index) => (
              <button
                key={index}
                className={`flex items-center justify-center flex-col 2xl:px-2 px-[4px] py-2 bg-custom-white shadow-base border border-custom-gray-200 rounded-md w-[6.5rem] h-[6.5rem] md:w-[8rem] md:h-[7rem] 2xl:w-[9.5rem] 2xl:h-[8.5rem] ${
                  selectedCategory === category.id
                    ? "shadow-lg"
                    : "bg-custom-white text-custom-atrament"
                } hover:bg-custom-white hover:drop-shadow-xl transition duration-200`}
                onClick={() => {
                  if (isMobile) {
                    scrollToSection();
                  }
                  handleCategorySelect(category.id);
                }}
              >
                <div
                  className={`flex items-center justify-center h-1/2 w-full ${
                    selectedCategory === category.id
                      ? "text-custom-red"
                      : "text-custom-atrament"
                  }`}
                >
                  <IconComponent
                    iconPath={category.image.url}
                    className={`${
                      selectedCategory === category.id ? "text-3xl" : "text-2xl"
                    }`}
                  />
                </div>
                <div className="flex items-center justify-center w-full h-1/2 mt-2">
                  <p
                    className={`text-xs md:text-sm 2xl:text-base ${
                      selectedCategory === category.id
                        ? "font-bold"
                        : "font-light"
                    }`}
                  >
                    {category.name}
                  </p>
                </div>
              </button>
            ))}
          </div>
          <div />
        </div>

        {/* Product items */}
        <div
          id="productSection"
          className="flex flex-col mt-10 w-full text-custom-atrament justify-self-center  min-h-48 md:px-20 bg-custom-gray"
        >
          <div className="flex w-full items-center gap-2 pt-4 pb-3 pl-4 md:pl-0">
            <span className="flex items-center justify-center w-9 h-9 rounded-xl text-custom-red bg-custom-white">
              <RiAlignItemLeftLine className="text-lg" />
            </span>

            <h2 className="flex w-full justify-start items-center uppercase text-custom-blue font-semibold text-base">
              Ponuka zariadení
            </h2>
          </div>

          <div className="pb-4">
            {/* <div className="flex flex-wrap flex-row xl:gap-2 md:gap-4 items-center md:justify-start justify-center"> */}
            <div className="flex flex-wrap flex-row md:gap-2 gap-3 items-center md:justify-start justify-center mx-4 md:mx-0">
              {devices?.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className={
                    item.rentCategoryId === category?.id
                      ? "flex flex-row md:flex-col border rounded-lg border-custom-gray-200 items-center md:justify-center justify-start md:p-4 py-2 bg-custom-white w-full md:w-[15rem] md:h-[20rem] h-[10rem]  cursor-pointer hover:shadow-2xl transition duration-200"
                      : "hidden"
                  }
                  onClick={() =>
                    handleItemClick(item.name, item.id, item.rentCategoryId)
                  }
                >
                  {item.images?.length > 0 ? (
                    <div className="flex justify-start md:justify-center md:w-full md:h-[10rem] h-full w-1/2 mr-4 md:mr-0">
                      <img
                        src={item.images?.[0].url}
                        alt={item.images?.[0].name}
                        loading="lazy"
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  ) : (
                    <div className="flex justify-center items-center md:w-full md:h-[10rem] h-full w-1/2 mr-4 md:mr-0">
                      {" "}
                      <IconComponent
                        iconPath={
                          "/data/images/categories/1221637e-a67b-4dd0-ad15-701034d13804.svg"
                        }
                        className="text-5xl"
                      />
                    </div>
                  )}
                  <div className="flex flex-col md:w-full md:h-[8rem] h-full w-1/2">
                    <p className="flex md:text-center uppercase items-start md:items-center sm:justify-center font-base text-sm pt-4 md:h-1/2 md:w-full h-full w-full">
                      {item.name}
                    </p>
                    <p className="flex items-start md:text-center uppercase md:items-center sm:justify-center font-light text-xs pt-2 md:h-1/2 md:w-full h-full w-full">
                      {item.model}
                    </p>
                    {item.type === Types.RentType.RENT &&
                      (item.price5h != null ? (
                        <p className="flex items-end items-start md:items-center sm:justify-center font-bold h-1/2 w-full py-2 md:py-0">
                          od {formatCurrency(item.price5h)} s DPH
                        </p>
                      ) : item.price24h != null ? (
                        <p className="flex items-end justify-center font-bold h-1/2 w-full py-2 md:py-0">
                          {formatCurrency(item.price24h)} s DPH / deň
                        </p>
                      ) : item.price != null ? (
                        <p className="flex items-end justify-center font-bold h-1/2 w-full py-2 md:py-0">
                          {formatCurrency(item.price)} s DPH
                        </p>
                      ) : null)}
                    {item.type === Types.RentType.SERVICE &&
                      item.price != null && (
                        <p className="flex items-end justify-center font-bold h-1/2 w-full py-2 md:py-0">
                          {formatCurrency(item.price)} s DPH
                        </p>
                      )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
